<template lang="pug">
	//- Ассет, созданный агентом: у картинок и видео показываем миниатюру, у остальных типов - только текст
	//- Генерация картинки агентом: пока идёт генерация - анимация ожидания, после завершения под миниатюрой время генерации, модель и стоимость
	.ai-chat-message-content.ai-chat-asset-created(:class="{error: message.options.generationStatus === 'error'}")
		.ai-chat-asset-created-text
			i.fa(:class="getIcon()")
			span {{message.message}}
		//- Миниатюру созданного ассета можно перетащить во фрейм превью (см. PreviewFrameDrop.vue и Asset.FrameDrop.js)
		.ai-chat-asset-created-thumbnail(v-if="message.options.url" :draggable="isFrameDropDraggable(getCreatedAsset())" v-on:dragstart="startFrameDropAssetDrag($event, getCreatedAsset())" v-on:dragend="finishFrameDropDrag()")
			img(v-if="message.options.assetType === 'image'" :src="message.options.url" :alt="message.options.assetCodename" :class="{disabled: !isCreativeSelected()}" v-on:load="$emit('thumbnail-loaded', message)" v-on:click="showAssetImageGeneration()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: isCreativeSelected() ? 'Open AI Image Generation of this asset' : 'Open the creative of this chat to edit the asset'}")
			video(v-else-if="message.options.assetType === 'video'" :src="message.options.url" controls muted preload="metadata" v-on:loadedmetadata="$emit('thumbnail-loaded', message)")
			//- У Spine данные скелета и атласа берутся из ассета версии (если ассеты версии чата загружены), текстура - url из сообщения.
			//- cacheKey - чтобы скелет брался из общего кэша разобранных данных (SpinePlayer), а не разбирался при каждой перерисовке чата
			SpinePlayer.ai-chat-asset-created-spine(v-else-if="message.options.assetType === 'spine' && getSpineAsset()" :json="getSpineAsset().options.json" :atlas="getSpineAsset().options.atlas" :imageUrl="message.options.url" :cacheKey="getSpineCacheKey()" :width="240" :height="180" v-on:loaded="$emit('thumbnail-loaded', message)")
		.ai-chat-asset-created-info(v-if="message.options.generationStatus === 'completed'") {{getGenerationInfo()}}
</template>

<script>
	import { Version } 			from './../../services/Version'
	import { Creative } 			from './../../services/Creative'

	import SpinePlayer 		from './../Dashboard/SpinePlayer'

	import { FrameDropThumbnails }	from './../Dashboard/PreviewFrameDrop'

	export default {
		name: "AIAgentMessageAssetCreated",
		mixins: [FrameDropThumbnails],
		components: {
			SpinePlayer
		},
		props: ['message'],
		methods: {
			// Ассет сообщения в открытой версии креатива: перетаскивать во фрейм можно только ассеты открытой версии
			getCreatedAsset() {

				if (this.message['version_id'] !== Version.SelectedVersion?.id) return null;

				return Asset.getAsset(Version.SelectedVersion, this.message.options.assetCodename);

			},
			// Иконка сообщения об ассете: во время генерации - круговая анимация ожидания, при ошибке - предупреждение, иначе - тип ассета
			getIcon() {

				let options = this.message.options;

				if (options.generationStatus === 'generating' || options.generationStatus === 'removing-background') return 'fa-spinner fa-spin';
				if (options.generationStatus === 'error') return 'fa-exclamation-triangle';

				return {video: 'fa-film', image: 'fa-picture-o', spine: 'fa-child'}[options.assetType] || 'fa-file-o';

			},
			// Ассет Spine сообщения с данными скелета и атласа (null - версия чата не загружена или ассет удалён)
			getSpineAsset() {

				let version = Version.getVersion(this.message["version_id"]),
					asset = version ? Asset.getAsset(version, this.message.options.assetCodename) : null;

				return asset?.type === 'spine' && asset.options?.json && asset.options?.atlas ? asset : null;

			},
			// Ключ ассета для общего кэша разобранных скелетов Spine (SpinePlayer): getAsset клонирует options при каждом вызове,
			// поэтому без ключа скелет разбирался бы заново при каждой перерисовке чата
			getSpineCacheKey() {

				return Asset.getSpineCacheKey(this.getSpineAsset());

			},
			// Окно генерации ассета открывается только в открытом креативе чата
			isCreativeSelected() {

				return Creative.SelectedCreative?.id === this.message["creative_id"];

			},
			// Клик по миниатюре картинки, созданной агентом: открываем окно AI Image Generation этого ассета
			showAssetImageGeneration() {

				if (!this.isCreativeSelected()) return;

				let version = Version.getVersion(this.message["version_id"]);
				if (!version) return;

				let asset = Asset.getAsset(version, this.message.options.assetCodename);
				if (!asset) return;

				Broadcast.call("Show AssetImageGeneration", [asset]);

			},
			// Статистика завершённой генерации картинки: время, модель и стоимость (как в сообщении со статистикой работы агента)
			getGenerationInfo() {

				let options = this.message.options,
					seconds = (options.generationDuration || 0) / 1000;

				let duration = seconds < 60 ? `${seconds.toFixed(1)}s` : `${Math.floor(seconds / 60)}m ${_.padStart(Math.round(seconds % 60) + '', 2, '0')}s`;

				return [
					`Time: ${duration}`,
					`Model: ${options.generationModel || 'n/a'}`,
					`Cost: ${_.isFinite(options.generationCost) ? '$' + options.generationCost.toFixed(4) : 'n/a'}`
				].join(' · ');

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Ассет, созданный агентом (с миниатюрой картинки или видео)
				&.asset-created
					.ai-chat-asset-created
						background-color: rgba(77,189,116,0.12)
						border: 1px solid #4dbd74

						// Ошибка генерации картинки
						&.error
							background-color: rgba(248,108,107,0.12)
							border-color: #f86c6b

							.ai-chat-asset-created-text i.fa
								color: #f86c6b

					.ai-chat-asset-created-text
						display: flex
						flex-direction: row
						align-items: baseline
						gap: 8px
						word-break: break-all

						i.fa
							color: #4dbd74

					.ai-chat-asset-created-thumbnail
						margin-top: 8px

						img, video, .ai-chat-asset-created-spine
							display: block
							max-width: 240px
							max-height: 180px
							border-radius: 4px
							background: repeating-conic-gradient(#3a4248 0% 25%, #2f353a 0% 50%) 50% / 16px 16px

						.ai-chat-asset-created-spine
							display: flex

						img
							cursor: pointer
							outline: 1px solid transparent

							&:hover
								outline-color: #4dbd74

							&.disabled
								cursor: default
								outline-color: transparent

					// Время генерации, модель и стоимость под миниатюрой
					.ai-chat-asset-created-info
						margin-top: 6px
						font-size: 11px
						color: #adb6bf

</style>
